export const getDateRange = (shortestDeadline: number) => {
  return [3, 6, 12, 24, 36, 48, 72, 96, 120, 168, 240, 336]
    .filter((item) => item >= shortestDeadline)
    .map((item) => ({
      id: item,
      value: item < 49 ? item + " hours" : item / 24 + " days",
    }));
};
